import React from 'react';

const TermsOfService = ({ setCurrentPage }) => {
  return (
    <div className="container" style={{ textAlign: 'left', maxWidth: '800px', margin: '0 auto' }}>
      <h2>서비스 이용약관 (초안)</h2>

      <h4>제1조 (목적)</h4>
      <p>이 약관은 LOTTO & TAROT(이하 '서비스')이 제공하는 로또 번호 조합 관련 제반 서비스의 이용과 관련하여 회사와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</p>

      <h4>제2조 (정의)</h4>
      <p>1. '서비스'라 함은 회사가 제공하는 LOTTO & TAROT 관련 제반 서비스를 의미합니다.</p>
      <p>2. '회원'이라 함은 회사의 '서비스'에 접속하여 이 약관에 따라 '회사'와 이용계약을 체결하고 '회사'가 제공하는 '서비스'를 이용하는 고객을 말합니다. (※ 현재는 비회원제이므로, 향후 회원제 도입 시 적용)</p>
      <p>3. '이용자'라 함은 '서비스'에 접속하여 본 약관에 따라 '회사'가 제공하는 '서비스'를 이용하는 회원 및 비회원을 모두 포함합니다.</p>

      <h4>제3조 (약관의 게시와 개정)</h4>
      <p>① 회사는 이 약관의 내용을 이용자가 쉽게 알 수 있도록 서비스 초기 화면 또는 푸터 영역에 게시합니다.</p>
      <p>② 회사는 '약관의 규제에 관한 법률', '정보통신망 이용촉진 및 정보보호 등에 관한 법률' 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.</p>

      <h4>제4조 (서비스의 제공 및 변경)</h4>
      <p>① 회사는 다음과 같은 업무를 수행합니다.<br/>1. 타로 카드 및 통계 데이터를 기반으로 한 로또 번호 조합 생성 및 추천<br/>2. 로또 관련 통계 데이터 분석 정보 제공<br/>3. 기타 회사가 정하는 부가 서비스</p>
      <p>② 회사는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 '서비스'를 변경할 수 있습니다.</p>

      <h4>제5조 (회사의 의무)</h4>
      <p>회사는 관련법과 이 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 '서비스'를 제공하기 위하여 최선을 다하여 노력합니다.</p>

      <h4>제6조 (이용자의 의무)</h4>
      <p>이용자는 다음 행위를 하여서는 안 됩니다.<br/>1. 서비스의 비정상적인 이용 또는 서버에 부하를 가하는 행위<br/>2. 타인의 정보를 도용하는 행위<br/>3. 회사의 저작권 등 지적재산권에 대한 침해<br/>4. 기타 불법적이거나 부당한 행위</p>

      <h4>제7조 (저작권의 귀속)</h4>
      <p>'서비스' 내 회사가 작성한 저작물에 대한 저작권 및 기타 지적재산권은 회사에 귀속됩니다.</p>

      <h4>제8조 (면책조항)</h4>
      <p>① (중요) '서비스'에서 제공하는 모든 정보, 번호 조합, 분석 데이터는 타로의 수비학적 해석과 통계 데이터를 융합하여 새로운 영감과 즐거움을 제공하는 것을 목표로 하는 엔터테인먼트 콘텐츠입니다.</p>
      <p>② 제공되는 모든 정보와 조합은 과학적 근거가 없으며, 오직 재미와 참고용으로만 사용해야 합니다.</p>
      <p>③ 회사는 '서비스'가 로또 당첨을 보장하거나 특정 조합의 당첨 확률을 높여준다고 보증하지 않습니다.</p>
      <p>④ 이용자가 '서비스'를 이용함에 있어 예상했던 이익을 얻지 못하거나, 서비스 이용을 통해 얻은 결과의 해석 및 선택으로 인해 발생하는 모든 손실이나 손해에 대한 최종적인 책임은 전적으로 이용자 본인에게 있습니다.</p>

      <h4>제9조 (유료 서비스)</h4>
      <p>회사는 향후 유료 서비스를 제공할 수 있으며, 이 경우 해당 서비스 이용에 대한 별도의 약관이나 정책을 통해 이용자에게 고지합니다.</p>

      <h4>제10조 (후원)</h4>
      <p>① 이용자는 서비스를 제공하는 개발자에게 자발적인 의사에 따라 후원금을 지급할 수 있습니다.</p>
      <p>② 후원금은 서비스의 안정적인 유지 및 기능 개선을 위해 사용됩니다.</p>
      <p>③ 지급된 후원금은 순수한 기부의 성격을 가지므로, 원칙적으로 환불이 불가능합니다.</p>

      <h4>부칙</h4>
      <p>1. 이 약관은 2025년 10월 16일부터 시행됩니다.</p>

      <button onClick={() => setCurrentPage('main')} className="action-button" style={{ marginTop: '2rem' }}>메인으로 돌아가기</button>
    </div>
  );
};

export default TermsOfService;
